<template>
  <RecaptchaV2
    ref="recaptcha"
    :sitekey="sitekey"
    @load-callback="onVerify"
    @expired-callback="onExpired"
    @error-callback="onError"
  />
</template>

<script>
  import { RecaptchaV2 } from "vue3-recaptcha-v2";

  export default {
    name: "ReCaptcha",
    components: {
      RecaptchaV2,
    },
    data() {
      return {
        verifyKey: null,
        // Get sitekey from environment variable with fallback
        sitekey:
          import.meta.env.VITE_RECAPTCHA_SITEKEY || "6LeL8EEUAAAAAFsMIpbHNjtrrxSD9vyAka83H3nS",
      };
    },
    methods: {
      onVerify(response) {
        // console.log('Recaptcha Verify: ' + response);
        this.verifyKey = response;
      },
      onExpired() {
        // console.log('Recaptcha Expired');
        this.verifyKey = null;
      },
      onError() {
        // console.log('Recaptcha Error');
        this.verifyKey = null;
      },
      resetRecaptcha() {
        if (this.$refs.recaptcha && this.$refs.recaptcha.reset) {
          this.$refs.recaptcha.reset();
        }
        this.verifyKey = null;
      },
    },
  };
</script>
